<template>
    <div class="bs-tabs">
        <div class="tabs">
            <ul class="nav nav-tabs">
                <li v-for="tab in tabs" :key="tab.href" :class="{ 'active': tab.isActive }">
                    <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
                </li>
            </ul>
        </div>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bs-tabs",
        data() {
            return {tabs: [] };
        },
        created() {
            this.tabs = this.$children;
        },
        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.name == selectedTab.name);
                });
            }
        },
        mounted() {
            console.log("mounted")
        }
    }
</script>

<style lang="less" scoped>
    .bs-tabs {
        li a {
            color: #1b1e21;
        }
    }
</style>